export default __webpack_public_path__ + "static/media/mons14.af20589f.jpg";